export function initNavbar() {
    document.addEventListener('click', (e) => {
        const toggler = e.target.closest('.navbar-toggler');
        if (toggler) {
            const targetId = toggler.getAttribute('data-target') || toggler.getAttribute('data-bs-target');
            if (targetId) {
                const target = document.querySelector(targetId);
                if (target) {
                    target.classList.toggle('show');
                    const isExpanded = target.classList.contains('show');
                    toggler.setAttribute('aria-expanded', isExpanded);
                }
            }
        }
    });
}
